import { partnerClient } from '@modules/core/services';
import { Campaign } from '../services/campaign/campaign.type';

export const fetchCampaigns = async (status: string): Promise<Campaign[]> => {
  return await partnerClient.get(`/campaign_tracking`, {
    params: {
      status,
    },
  });
};
